<footer class="footer border-top border-6">
  <div class="container-fluid">
    <div class="row justify-content-between align-items-center">
      <div class="col-6 text-right">
        &copy;
        {{currentYear | date: 'yyyy'}},
        <a href="https://renova.net.br/site/" target="_blank">Renova Soluções</a> em Tecnologia.
      </div>
    </div>
  </div>
</footer>